import apiClient from '@/utils/api-client'
import {BufferEventRequest} from "@/model/models";

class MonitoringService {
    public sendMonitoringBuffer(data: BufferEventRequest): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            apiClient.post('/api/v1/monitoring/buffer', data)
                .then(() => resolve(true))
                .catch(() => reject(false));
        });
    }
}

export default new MonitoringService()
